import React, { useEffect, useState } from "react";
import { useFetch } from "lib/useFetch";
import ErrorBoundary from "lib/ErrorBoundary";
import { LoadingSpinner } from "lib/Spinner";
import { DataErrorMsg } from "pages/AnalystDirectory/AnalystDirectory";
import { parseFaqItems } from "./api/parseFaqItems";
import { FaqHeader } from "./FaqHeader";
import { features } from "app/features";
import { FaqBody } from "./FaqBody";

const FAQ_CONTENT_URL = `/research/japi/content/faq`;
const FAQ_URL = `${process.env.PUBLIC_URL}/api/faq/faq.json`;

export const Faq = () => {
  const url = features.useContentApiForPages.faq ? FAQ_CONTENT_URL : FAQ_URL;
  const [data, isLoading, isError] = useFetch(url, null, "GET");
  const [faqItems, categories, isParseError] = parseFaqItems(data);
  const [cardRefs, setCardRefs] = useState();
  const hash = decodeURI(window.location.hash);

  useEffect(() => {
    const nodeId = hash.replace("#", "");
    const node = cardRefs?.[nodeId]?.current;

    window.scrollTo(0, node?.offsetTop + 520);
  }, [isLoading, faqItems.length, hash, cardRefs]);

  return (
    <ErrorBoundary>
      <FaqHeader />
      {isLoading && <LoadingSpinner />}
      {(isError || isParseError) && <DataErrorMsg />}
      {faqItems && faqItems.length && (
        <FaqBody faq={faqItems} categories={categories} setCardRefs={setCardRefs} cardRefs={cardRefs} />
      )}
    </ErrorBoundary>
  );
};
